var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTts20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M1.25 3.125c0-1.036.84-1.875 1.875-1.875h8.125c1.036 0 1.875.84 1.875 1.875v3.766a.625.625 0 1 1-1.25 0V3.125a.625.625 0 0 0-.625-.625H3.125a.625.625 0 0 0-.625.625v8.125c0 .345.28.625.625.625h3.75a.625.625 0 1 1 0 1.25h-3.75A1.875 1.875 0 0 1 1.25 11.25z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M6.555 5.625H5.313A.31.31 0 0 1 5 5.313v-.625c0-.173.14-.313.313-.313h3.75c.172 0 .312.14.312.313v.625c0 .172-.14.312-.312.312H7.805v3.438c0 .172-.14.312-.313.312h-.625a.31.31 0 0 1-.312-.312zM15.323 7.016a.625.625 0 0 1 .88.088 8.5 8.5 0 0 1 1.922 5.396 8.5 8.5 0 0 1-1.923 5.396.625.625 0 0 1-.967-.792 7.24 7.24 0 0 0 1.64-4.604 7.24 7.24 0 0 0-1.64-4.604.625.625 0 0 1 .088-.88",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M13.292 8.329a.625.625 0 0 1 .88.088 6.43 6.43 0 0 1 1.453 4.083c0 1.55-.546 2.973-1.454 4.083a.625.625 0 0 1-.967-.791 5.18 5.18 0 0 0 1.171-3.292c0-1.252-.44-2.398-1.171-3.292a.625.625 0 0 1 .088-.88",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M11.23 9.547a.625.625 0 0 1 .88.09 4.52 4.52 0 0 1 1.015 2.863 4.52 4.52 0 0 1-1.015 2.864.625.625 0 1 1-.97-.79 3.27 3.27 0 0 0 .735-2.074 3.27 3.27 0 0 0-.735-2.074.625.625 0 0 1 .09-.88M9.201 10.858a.625.625 0 0 1 .879.093c.341.422.545.963.545 1.549a2.46 2.46 0 0 1-.545 1.549.625.625 0 0 1-.972-.785 1.2 1.2 0 0 0 .267-.764 1.2 1.2 0 0 0-.267-.764.625.625 0 0 1 .093-.879",
  clipRule: "evenodd"
})));
export default SvgTts20;